export const TICKER_REGEX = /\$([A-Z]{1,5})\b/g;

export function navigateToTicker(symbol: string): void {
  window.open(`/ticker/${symbol}`, '_blank');
}

/**
 * Preprocess content to replace $TICKER mentions with markdown links.
 * The links use a /ticker/ prefix that can be intercepted by ReactMarkdown.
 */
export function preprocessTickers(content: string): string {
  return content.replace(TICKER_REGEX, '[$$$1](/ticker/$1)');
}
